module.exports = __webpack_public_path__ + "static/media/team1.b3d0b714.jpeg";